// Compatibility re-export (BKPE-27795). See `features/observability/logger/middleware/error-categories`.
export * from 'features/observability/logger/middleware/error-categories';
export { default } from 'features/observability/logger/middleware/error-categories';
